/**
 * Avatar Upload Handler
 * Handles avatar image upload with validation and preview
 */

(function () {
    'use strict';
    // DOM Elements
    var avatarInput, avatarEditBtn, avatarPreview;
    /**
     * Initialize avatar upload
     */
    function init() {
        avatarInput = document.getElementById('avatarInput');
        avatarEditBtn = document.getElementById('avatarEditBtn');
        avatarPreview = document.getElementById('avatarPreview');
        if (!avatarInput || !avatarEditBtn) {
            return; // Not on profile page or viewing someone else's profile
        }
        // Setup event listeners
        setupEventListeners();
    }
    /**
     * Setup event listeners
     */
    function setupEventListeners() {
        // Trigger file picker on button click
        if (avatarEditBtn) {
            avatarEditBtn.addEventListener('click', function (e) {
                e.preventDefault();
                avatarInput.click();
            });
        }
        // Handle file selection
        if (avatarInput) {
            avatarInput.addEventListener('change', function (e) {
                var file = e.target.files[0];
                if (!file) return;

                // Validate file
                if (!validateFile(file)) {
                    avatarInput.value = '';
                    return;
                }
                // Upload file
                uploadAvatar(file);
            });
        }
    }

    /**
     * Validate file type and size
     */
    function validateFile(file) {
        // Valid MIME types
        var validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
        if (validTypes.indexOf(file.type) === -1) {
            alert('Please select an image file (JPG, PNG, GIF, or WebP)');
            return false;
        }

        // Max size 5MB
        var maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            alert('File size exceeds 5MB limit. Please choose a smaller image.');
            return false;
        }

        return true;
    }

    /**
     * Upload avatar
     */
    function uploadAvatar(file) {
        var formData = new FormData();
        formData.append('avatar', file);

        // Show loading state
        showLoading(true);

        // Send AJAX request
        fetch('/user/uploadAvatar', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                showLoading(false);

                if (result.success) {
                    // Update avatar preview
                    var avatarUrl = '/upload/avatars/' + result.avatar;
                    if (avatarPreview) {
                        avatarPreview.style.backgroundImage = 'url("' + avatarUrl + '")';
                    }

                    // Update header avatar if it exists
                    updateHeaderAvatar(avatarUrl);

                    // Clear input
                    avatarInput.value = '';

                    showMessage('success', result.message || 'Avatar updated successfully');
                } else {
                    showMessage('error', result.message || 'Upload failed');
                    avatarInput.value = '';
                }
            })
            .catch(function (error) {
                console.error('Avatar upload error:', error);
                showLoading(false);
                showMessage('error', 'Upload failed. Please check your connection and try again.');
                avatarInput.value = '';
            });
    }

    /**
     * Show/hide loading state
     */
    function showLoading(show) {
        if (!avatarPreview) return;

        if (show) {
            // Add semi-transparent overlay
            avatarPreview.style.opacity = '0.5';
            // Disable edit button
            if (avatarEditBtn) {
                avatarEditBtn.disabled = true;
                avatarEditBtn.style.cursor = 'wait';
            }
        } else {
            // Remove overlay
            avatarPreview.style.opacity = '1';
            // Enable edit button
            if (avatarEditBtn) {
                avatarEditBtn.disabled = false;
                avatarEditBtn.style.cursor = 'pointer';
            }
        }
    }

    /**
     * Update header avatar if it exists
     */
    function updateHeaderAvatar(url) {
        // Look for avatar in navigation/header
        var headerAvatars = document.querySelectorAll('.header-avatar, nav img[alt*="avatar"], header img[alt*="avatar"]');
        for (var i = 0; i < headerAvatars.length; i++) {
            var img = headerAvatars[i];
            if (img.tagName === 'IMG') {
                img.src = url;
            } else {
                img.style.backgroundImage = 'url("' + url + '")';
            }
        }
    }

    /**
     * Show message to user
     */
    function showMessage(type, message) {
        // Simple alert for now - can be replaced with toast notification
        if (type === 'success') {
            alert(message);
        } else {
            alert('Error: ' + message);
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
